import { ahtWtInitialSupplyChain } from "./aht-wt-initial-supply-chain";
import type { PathwayChain } from "../types/chain.types";

const chainRegistry: Record<string, PathwayChain> = {
  [ahtWtInitialSupplyChain.id]: ahtWtInitialSupplyChain,
};

export function getChain(chainId: string): PathwayChain | undefined {
  return chainRegistry[chainId];
}

export function resolveNextPathway(
  chainId: string,
  context: Record<string, unknown>,
  audit: any,
): string | null {
  if (chainId === "aht-wt-selector-chain") {
    return "aht-wt-shared-assessment";
  }

  if (chainId === "aht-wt-shared-assessment-chain") {
    const consultationType = context["aht-sel-consultation-type"];
    if (consultationType === "reinitiation")
      return "aht-wt-reinitiation-drug-select";
    return "aht-weight-selection";
  }

  if (chainId === "aht-wt-reinitiation-drug-select-chain") {
    const chain = chainRegistry["aht-wt-initial-supply-chain"];
    const drugId =
      audit?.drugResolution?.resolvedDrugId ?? context["resolvedDrugId"];
    if (chain && drugId) return chain.drugInitialMap[drugId] ?? null;
    return null;
  }

  const chain = chainRegistry[chainId];
  if (chain?.drugInitialMap) {
    const drugId =
      audit?.drugResolution?.resolvedDrugId ?? context["resolvedDrugId"];
    if (drugId) return chain.drugInitialMap[drugId] ?? null;
  }

  return null;
}
